<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <div class="p-col-12 mainFormPadding">
                <div class="card">
                    <p-toast key="toastmsg"></p-toast>
                    <form [formGroup]="categoryForm" *ngIf="this.categoryForm" (ngSubmit)="onSubmit()">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    Edit Sub Category
                                </h3>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-4 namecategory">
                                    <label for="name">Name</label>
                                    <input formControlName="name" type="text" pInputText class="form-control"
                                        [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Category Name is required</div>
                                        <div *ngIf="f.name.errors">Numbers, Space and Special characters not allowed.
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4 addFormDropDown">
                                    <label for="parent_category">Select Parent Category <span
                                            class="mandatory-fields">*</span></label>
                                    <p-dropdown inputId="parent_category" [options]="categorylist"
                                        formControlName="parent_category" placeholder="Select" optionLabel="name"
                                        (ngModelChange)="onParentSelect($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.parent_category.errors }"></p-dropdown>
                                    <div *ngIf="submitted && f.parent_category.errors" class="invalid-feedback">
                                        <div *ngIf="f.parent_category.errors.required">Please, Select Parent Category
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-4  statusdivMain">
                                    <label for="firstname6">Status</label>
                                    <p-inputSwitch class="checkbox-mt-10" formControlName="status"></p-inputSwitch>
                                </div>

                                <!-- <div class="p-field p-col-3">
                                    <label for="status">Status</label>
                                    <p-dropdown inputId="status" [options]="statuses" formControlName="status"
                                        placeholder="Select" optionLabel="label"
                                        (ngModelChange)="onStatusSelect($event)"></p-dropdown>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Please Select Status</div>
                                    </div>
                                </div> -->
                                <div class="p-field p-col-12">
                                    <label for="description">Description</label>
                                    <textarea inputId="textarea" rows="3" cols="30" formControlName="description"
                                        pInputTextarea></textarea>
                                </div>
                                <div class="p-field p-col-12 uploadBtn">
                                    <div class="subTitleLable">
                                        <h4>Category Image</h4>
                                    </div>
                                    <!-- <p-fileUpload name="uploadFiles[]" chooseLabel="Upload" uploadLabel="Show data"
                                        cancelLabel="Cancel" accept="image/*" maxFileSize="1000000" auto="auto"
                                        customUpload="true" (uploadHandler)="picUploader($event)">
                                        <ng-template pTemplate="content">
                                        </ng-template>
                                    </p-fileUpload>  -->
                                    <p-fileUpload #fileUpload mode="advanced" name="uploadFiles[]" chooseLabel="Upload" uploadLabel="Show data" cancelLabel="Cancel"
                                        accept="image/*" maxFileSize="1000000" auto="false" customUpload="true"
                                        (onSelect)="onFileSelect($event)" (onRemove)="removeFile($event)">
                                        <ng-template pTemplate="content">
                                        </ng-template>
                                    </p-fileUpload>
                                        <div class="column banner-images col" *ngIf="showUploadedpic">
                                        <div class="imagediv d-flex gap-3 ">
                                            <img class="thumbnail-image" src="{{ imageProfile }}" />
                                            <ul class="actionList">
                                                <li>
                                                    <button type="button" class="editBtn"><img
                                                            src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
                                                </li>
                                                <li>
                                                    <button type="button" class="deleteBtn"><img
                                                            src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                <div class="p-field p-col-12">
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="p-fluid p-formgrid p-grid  p-col-4">

                                <div class="p-field p-col-12" *ngIf="showUploadedpic">
                                    <label for="categoryimg " class="p-col-12" style="visibility: hidden;">Category
                                        Image</label>
                                    <img src="{{ imageProfile }}" alt="freya-layout" height="auto" width="200px" />
                                </div>
                            </div> -->
                        </div>
                        <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">

                            <div class="button-div d-flex">
                                <button pButton pRipple label="Save" icon="pi pi-check"
                                    class="p-button-success save-btn p-mr-3"></button>
                                <!-- <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="userForm.invalid"></button> -->
                                <!-- <button pButton pRipple label="Reset" icon="pi pi-times" type="reset" (click)="onReset()"></button> -->
                                <button pButton pRipple type="button" icon="pi pi-times" label="Back"
                                    class="cancel-btn" (click)="backLink()"></button>
                            </div>
                        </div>

                    </form>
                </div>
                <div class="button-set back">
                    <div class="p-fluid p-formgrid">
                        <p-toast></p-toast>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p-dialog [(visible)]="cropDialog" [closable]="true" (onHide)="onDialogHide()" [modal]="true" [appendTo]="'body'"
        [style]="{width: '720px'}" styleClass="custom-crop-dialog">
        <ng-template pTemplate="header">
            <div class="crop-header-wrapper">
                <div class="crop-header-icon-box">
                    <i class="pi pi-image header-icon"></i>
                </div>
                <div class="crop-header-text">
                    <h5 class="crop-dialog-title">{{cropDialogTitle}}</h5>
                    <p class="crop-dialog-subtitle">{{cropDialogSubtitle}}</p>
                </div>
            </div>
        </ng-template>
    
        <div class="crop-dialog-content-wrapper">
            <div class="crop-toolbar-bar mb-3">
                <div class="toolbar-hint">
                    <i class="pi pi-sliders-h mr-2 hint-icon"></i>
                    <span>Zoom & Scale</span>
                </div>
                <div class="zoom-actions">
                    <button type="button" pButton icon="pi pi-search-plus" label="Zoom In" class="crop-btn zoom-btn"
                        (click)="zoomIn()"></button>
                    <button type="button" pButton icon="pi pi-search-minus" label="Zoom Out" class="crop-btn zoom-btn"
                        (click)="zoomOut()"></button>
                    <button type="button" pButton icon="pi pi-refresh" label="Reset" class="crop-btn reset-btn"
                        (click)="resetZoom()"></button>
                </div>
            </div>
    
            <div class="cropper-frame mb-3">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                    [aspectRatio]="300 / 300" [resizeToWidth]="300" [resizeToHeight]="300" [transform]="transform"
                    format="png" (imageCropped)="imageCropped($event)">
                </image-cropper>
            </div>
    
            <div class="crop-error-msg mb-3" *ngIf="croppedImageError">
                <i class="pi pi-exclamation-triangle mr-2"></i>
                <span>{{croppedImageError}}</span>
            </div>
    
            <div class="cropped-preview-box" *ngIf="croppedImage">
                <div class="preview-header">
                    <div class="preview-title">
                        <i class="pi pi-eye mr-2 text-primary"></i>
                        <span>Live Cropped Preview</span>
                    </div>
                    <span class="preview-ratio-badge">{{cropPreviewLabel}}</span>
                </div>
                <div class="preview-img-container">
                    <img [src]="croppedImage" alt="Cropped Preview" class="preview-img" />
                </div>
            </div>
        </div>
    
        <ng-template pTemplate="footer">
            <div class="dialog-footer-actions">
                <button type="button" pButton label="Cancel" icon="pi pi-times" class="cancel-action-btn"
                    (click)="onCropCancel()"></button>
                <button type="button" pButton label="Use Image" icon="pi pi-check" class="use-image-btn"
                    (click)="applyCrop()" [disabled]="!!croppedImageError || !croppedImage"></button>
            </div>
        </ng-template>
    </p-dialog>
    <!-- <p-dialog
      [(visible)]="cropDialog"
      [closable]="false"
      [modal]="true"
      [appendTo]="'body'"
      [style]="{width: '660px'}">
           <image-cropper 
               [imageChangedEvent]="imageChangedEvent"
               [maintainAspectRatio]="true"
               [aspectRatio]="512 / 512"
               [resizeToWidth]="512"
               [resizeToHeight]="512"
               format="jpeg"
               (imageCropped)="imageCropped($event)">
       </image-cropper>
    <img *ngIf="croppedImage" [src]="croppedImage" style="width: 150px; margin-top: 10px;" />
    <div class="error-msg crop-error-msg" *ngIf="croppedImageError">
        {{croppedImageError}}
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" class="p-button-text" (click)="onCropCancel()"></button>
        <button pButton label="Use Image" (click)="applyCrop()" [disabled]="!!croppedImageError"></button>
    </ng-template>
    </p-dialog> -->
</div>
